import React from 'react'

import { NetworkIconV2 } from '@/components/tokens/NetworkIconComponent'
import { WalletIcon } from '@/components/tokens/WalletIcon'
import RenderIf from '@/components/ui/render-if'
import { EVM_ICON_URL } from '@/constants'
import { useWallet } from '@/hooks'
import { cn } from '@/lib/utils'
import { INetwork } from '@/types'
import { isEvmChain } from '@/utils'

interface NetworkItemProps {
  network: INetwork
  onClick: () => void
  isSelected: boolean
  isDisabled?: boolean
  hasWallet?: boolean
  className?: string
}

const NetworkItem: React.FC<NetworkItemProps> = ({ network, onClick, isSelected, className }) => {
  const { wallets } = useWallet()
  const connectedWallet = wallets[network?.networkId]
  const networkIcon = isEvmChain(network?.networkId) ? EVM_ICON_URL : network?.networkLogoUri
  return (
    <button onClick={onClick} className={cn('w-full', className)}>
      <div
        className={cn(
          'flex w-full md:min-w-[150px] items-center gap-2 rounded-sm p-2 justify-between duration-300 text-white-48 ',
          isSelected ? 'bg-white-8 text-white' : 'hover:bg-white-12 hover:text-white'
        )}
      >
        <div className='flex gap-2 items-center'>
          <NetworkIconV2 url={networkIcon} className='size-8 rounded-md' />
          {isEvmChain(network?.networkId) ? 'EVM' : network?.networkName}
        </div>
        <RenderIf condition={connectedWallet}>
          <WalletIcon wallet={connectedWallet?.wallet} className='my-auto size-4 rounded-[6px] md:size-4' />
        </RenderIf>
      </div>
    </button>
  )
}

export default NetworkItem
